import StakeholderTable, { StakeholderTableProps } from './stakeholder-table';

export default StakeholderTable;
export type { StakeholderTableProps };
